import template from './location_distance.edit.html'
import controller from './location_distance.edit.controller'
import './location_distance.edit.scss'

const locationDistanceEditComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default locationDistanceEditComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/location_distance/edit/location_distance.edit.component.js